import type { WhichPrintedEnabled } from './orderPrintingConfig.type';
import type { WhichPrintedEnabledParams } from './orderPrintingConfig.model';

export function whichPrintedEnabled(params: WhichPrintedEnabledParams) {
  const { isEnabledCommand, isEnabledChecklist } = params;
  let result: WhichPrintedEnabled = 'all';
  if (isEnabledCommand && !isEnabledChecklist) return 'comanda';
  else if (!isEnabledCommand && isEnabledChecklist) return 'checklist';
  return result;
  // second condition is not needed, but it's here for better readability,
  // and it's possible active only checklist for old or manual configuration
}
